var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.978a1.089 1.089 0 111.089-1.089A1.089 1.089 0 0112 9.978zm.778 5.444a.778.778 0 01-1.556 0v-3.111a.778.778 0 011.556 0zM12 5a7 7 0 107 7 7 7 0 00-7-7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 16860",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgInfoIcon;